"use client";

import * as React from "react";

import { EntitySubtitle, EntityTitle } from "./EntityTitle";
import { cn } from "@/lib/utils";

export type TaskItemRowProps = {
  title: string;
  subtitle?: React.ReactNode;
  completed?: boolean;
  dateLabel?: string;
  dateClassName?: string;
  onToggle: () => void;
  checkboxAriaLabel: string;
};

export function TaskItemRow({
  title,
  subtitle,
  completed = false,
  dateLabel,
  dateClassName,
  onToggle,
  checkboxAriaLabel,
}: TaskItemRowProps) {
  return (
    <div className="flex items-start justify-between gap-2">
      <div className="flex-1 min-w-0">
        <EntityTitle
          as="h4"
          size="sm"
          truncate
          className={cn("min-w-0", completed && "line-through text-muted-foreground")}
        >
          {title}
        </EntityTitle>
        {subtitle ? (
          <EntitySubtitle tone="muted" lineClamp={2} className="mt-0.5">
            {subtitle}
          </EntitySubtitle>
        ) : null}
      </div>
      <div className="flex items-center gap-1.5 flex-shrink-0 ml-2">
        {dateLabel ? (
          <span className={cn("text-[11px] font-medium tabular-nums text-muted-foreground", dateClassName)}>
            {dateLabel}
          </span>
        ) : null}
        <input
          type="checkbox"
          checked={completed}
          onClick={(event) => event.stopPropagation()}
          onChange={(event) => {
            event.stopPropagation();
            onToggle();
          }}
          className="h-4 w-4 cursor-pointer border border-border"
          aria-label={checkboxAriaLabel}
        />
      </div>
    </div>
  );
}
